var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4239 2.1201L24.6952 1.57489C26.5283 1.26938 27.4448 1.11662 28.1937 1.19093C30.5356 1.42332 32.4901 3.07906 33.1044 5.35092C33.3008 6.07737 33.3008 7.00655 33.3008 8.86491V25.7528C33.3008 27.3032 33.3008 28.0784 33.1637 28.6902C32.6094 31.1645 30.4788 32.9693 27.9471 33.1094C27.321 33.144 26.5563 33.0166 25.027 32.7617L21.4239 32.1611C17.8224 31.5609 16.0217 31.2608 14.7995 30.1727C14.4022 29.819 14.0567 29.4111 13.7731 28.9611C12.9008 27.5766 12.9008 25.7511 12.9008 22.0999V12.1813C12.9008 8.53018 12.9008 6.7046 13.7731 5.32012C14.0567 4.8701 14.4022 4.46225 14.7995 4.10858C16.0217 3.02047 17.8224 2.72035 21.4239 2.1201Z",
    fill: "url(#paint0_linear_1773_951)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8 8.64062L1 17.1406M1 17.1406L7.8 25.6406M1 17.1406H16.3",
    stroke: "#5C5E63",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1773_951",
    x1: 34.472,
    y1: 0.223629,
    x2: 12.8303,
    y2: 0.272216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520834,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBCBC"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.84141c86757ebbb3c119b9e5ec7bb9fd.svg";
export { ForwardRef as ReactComponent };